﻿import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

// Import Component
import { BuilkComponent } from "./builk.component";
import { UserManagerComponent } from "./user-manager/user-manager.component";
import { CustomCostCodeComponent } from "./custom-costcode/custom-costcode.component";
import { ProFunnelComponent } from "./profunnel/profunnel.component";
import { PoItemComponent } from "./po-item/po-item.component";
import { ImageAppComponent } from "./image-app/image-app.component";
import { CouponSettingComponent } from "./coupon-setting/coupon-setting.component";
import { ImageTipSettingComponent } from "./image-tip-setting/image-tip-setting.component";
import { PackageSaleComponent } from "./package-sale/package-sale.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { VoucherComponent } from "./voucher/voucher.component";
import { MybuilkComponent } from "./mybuilk/mybuilk.component";
import { BannerListComponent } from "./banner-list/banner-list.component";
import { CustomCostcodeSaleComponent } from "./custom-costcode-sale/custom-costcode-sale.component";

const detailsRoutes: Routes = [
    {
        path: "builk", component: BuilkComponent,
        children: [
            {
                path: "",
                component: BuilkComponent
            },
            {
                path: "dashboard",
                component: DashboardComponent
            },
            {
                path: "usermanager",
                component: UserManagerComponent
            },
            {
                path: "customcostcode",
                component: CustomCostCodeComponent
            },
            {
                path: "profunnel",
                component: ProFunnelComponent
            },
            {
                path: "poitem",
                component: PoItemComponent
            },
            {
                path: "ImageApp",
                component: ImageAppComponent
            },
            {
                path: "coupon-setting",
                component: CouponSettingComponent
            },
            {
                path: "image-tips-setting",
                component: ImageTipSettingComponent
            },
            {
              path: "package-sale",
              component: PackageSaleComponent
            },
            {
              path: "custom-costcode-sale",
              component: CustomCostcodeSaleComponent
            },
            {
              path: "voucher",
              component: VoucherComponent
            },
            {
              path: "mybuilk",
              component: MybuilkComponent
            },
            {
              path: "banner-list",
              component: BannerListComponent
            }
        ]
    }
];
@NgModule({
    imports: [
        RouterModule.forChild(detailsRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class BuilkRoutingModule { }
